import { useNavigate } from "react-router-dom";
import RegisterView from "./view";
import usePersonalDataForm from "./hooks/usePersonalDataForm";

export default function Register() {
  const navigate = useNavigate();
  
  const {
    isDisabled,
    register,
    handleSubmit,
    errors,
    watch,
    setValue,
  } = usePersonalDataForm(navigate);
  
  const goBack = () => navigate("/");

  return <RegisterView
    goBack={goBack}
    isDisabled={isDisabled}
    register={register}
    errors={errors}
    handleSubmit={handleSubmit}
    watch={watch}
    setValue={setValue}
  />;
}
